<template>
  <div>
    <card>
      <div slot="header" class='text-center' style=''>
          頁面素材
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData" :show-header="false">
            <el-table-column prop="name" style='text-align:left;' />
            <el-table-column min-width="30px" label="">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs" @click="handleEdit(props.row)">
                  <i class="fa fa-edit" />
                </a>
                <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-xs" @click="handleDelete(props.row.id)" >
                  <i class="fa fa-close" />
                </a>
              </div>
            </el-table-column>
          </el-table>
          
          <div class="col-md-3">
            <el-dialog center :title="getTitle()" :visible.sync="modals.custom">
              <fg-input label="素材名稱"
                        type="text"
                        name="name"
                        data-vv-as="素材名稱"
                        v-model="form.name"
                        v-validate="'required'"  
                        :error="getError('name')"
                        required />
              <Editor v-model="form.content" />
              <div class="text-right">
                <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import lib from '../../lib'
  import tools from '../../tools'
  import Editor from '../../components/Editor'

  export default {
    name: "Stuff",
    props: ['saleGroup'],
    components: {
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      Editor: Editor
    },
    data() {
      return {
        form: {
          id: '',
          name: null,
          content: null
        },
        modals: {
          custom: false,
        },
        tableData: []
      }
    },
    async mounted() {
      // await this.getGroupData()
      if (this.saleGroup) {
        await this.getData()
      }
    },
    methods: {
      getTitle() {
        return (this.form.id == '')?'新增素材':'編輯素材'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;
          if (this.form.id === '') {
            _this.create()
          } else {
            _this.update()
          }
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject) {
          _this.form.id = ''
          _this.form.name = ''
          _this.form.content = ''
          resolve()
        })
      },
      async handlenew() {
        await this.clearForm();
        this.$emit('handlenew');
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      handleEdit(row) {
        this.form.id = row.id
        this.form.name = row.name
        this.form.content = row.content
        this.openModal('custom')
      },
      async getData() {
        var data = await lib.getStuffList(this.saleGroup.id)
        if (data.status == 0) {
          var result = data.result
          this.tableData = result.stuff
        }
      },
      async update() {
        var data = await lib.updateStuff(this.saleGroup.id, this.form.id, this.form);
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('已更新', '', 'success')
        }
      },
      async create() {
        var data = await lib.createStuff(this.saleGroup.id, this.form);
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('新增成功', '', 'success')
        } else {
          this.$swal('新增失敗', '', 'error')
        }
      },
      async handleDelete(id) {
        var result = await tools.confirmDialog(this, "確定要刪除?")
        if (result) {
          var data = await lib.deleteStuff(this.saleGroup.id, id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    },
    watch: {
      value: function(newValue) {
        this.content = newValue
      },
      tableData: function() {
        this.$emit('input', this.tableData)
      }
    }
  }
</script>


<style>
.hidden_header {
  display: none;
}

/* tr:nth-child(1) {  
  text-align: left;
  font-style: normal #AAA;
} */
</style>
